define('modules/editor/models/property_groups/button_style',['require','exports','module','./base','env','lib/util'],function (require, exports, module) {
  "use strict";
  var BasePG = require("./base"),
      config = require("env"),
      util = require("lib/util");

  module.exports = BasePG.extend({
    name: "button:style",

    properties: [
      "up-backgroundType",
      "up-backgroundColor",
      "up-color",
      "up-backgroundPosition",
      "up-backgroundRepeat",
      "up-imageUrl",
      "up-secondColor",
      "up-opacity",
      "up-borderStyle",
      "up-borderWidth",
      "up-borderColor",
      "up-borderRadius",
      "over-backgroundType",
      "over-backgroundColor",
      "over-color",
      "over-backgroundPosition",
      "over-backgroundRepeat",
      "over-imageUrl",
      "over-secondColor",
      "over-opacity",
      "over-borderStyle",
      "over-borderWidth",
      "over-borderColor",
      "over-borderRadius",
      "down-backgroundType",
      "down-backgroundColor",
      "down-color",
      "down-backgroundPosition",
      "down-backgroundRepeat",
      "down-imageUrl",
      "down-secondColor",
      "down-opacity",
      "down-borderStyle",
      "down-borderWidth",
      "down-borderColor",
      "down-borderRadius",
    ],

    defaults: {
      "up-backgroundType": "gradient",
      "up-backgroundColor": "#eeeeee",
      "up-color": "#000000",
      "up-backgroundPosition": "center center",
      "up-backgroundRepeat": "repeat",
      "up-imageUrl": "",
      "up-secondColor": "#cccccc",
      "up-opacity": 10,
      "up-borderStyle": "none",
      "up-borderWidth": 1,
      "up-borderColor": "#999999",
      "up-borderRadius": 5,

      "over-backgroundType": "gradient",
      "over-backgroundColor": "#cccccc",
      "over-color": "#000000",
      "over-backgroundPosition": "center center",
      "over-backgroundRepeat": "repeat",
      "over-imageUrl": "",
      "over-secondColor": "#999999",
      "over-opacity": 10,
      "over-borderStyle": "none",
      "over-borderWidth": 1,
      "over-borderColor": "#666666",
      "over-borderRadius": 5,

      "down-backgroundType": "gradient",
      "down-backgroundColor": "#999999",
      "down-color": "#000000",
      "down-backgroundPosition": "center center",
      "down-backgroundRepeat": "repeat",
      "down-imageUrl": "",
      "down-secondColor": "#666666",
      "down-opacity": 10,
      "down-borderStyle": "none",
      "down-borderWidth": 1,
      "down-borderColor": "#333333",
      "down-borderRadius": 5,
    },

    generateStyles: function ($el, id) {
      return [
        {
          selector: "#" + id + " .btn",
          rules: this._generateStateStyles("up")
        },
        {
          selector: "#" + id + " .btn:hover",
          rules: this._generateStateStyles("over")
        },
        {
          selector: "#" + id + " .btn:active",
          rules: this._generateStateStyles("down")
        }
      ];
    },

    _generateStateStyles: function (state) {
      var rules = {};

      rules = {
        "color": this.get(state + "-color"),
        "border-style": this.get(state + "-borderStyle") + " !important",
        "border-width": this.get(state + "-borderWidth") + "px !important",
        "border-color": this.get(state + "-borderColor") + " !important",
        "border-radius": this.get(state + "-borderRadius") + "px !important"
      };

      if (this.get(state + "-backgroundType") !== "gradient") {
        rules = _.extend(rules, {
          "background": util.hexToRgba(this.get(state + "-backgroundColor"), 1),
          "background-image": this._getBgImage(state),
          "background-position": this.get(state + "-backgroundPosition"),
          "background-repeat": this.get(state + "-backgroundRepeat")
        });
      } else {
        rules = _.extend(rules, {
          "background": this._generateGradient(this.get(state + "-backgroundColor"),
              this.get(state + "-secondColor"),
              this.get(state + "-opacity") / 10),
        });
      }
      return rules;
    },

    _getBgImage: function (state) {
      return this.get(state + "-backgroundType") === "image" ?
          this.get(state + "-imageUrl") && this.get(state + "-imageUrl") !== "none" ? this._generateImagePath(state) : ""
          : "";
    },

    _generateImagePath: function (state) {
      return "url(\"" + config.apiHost.replace("https:", "") + "/img/assets/" + this.get(state + "-imageUrl") + "\")";
    },

    _generateGradient: function (bgColor, secondColor, opacity) {
      return util.hexToRgba(bgColor, opacity) +
          " linear-gradient(to bottom, " +
          util.hexToRgba(bgColor, opacity) + ", " +
          util.hexToRgba(secondColor, opacity) + ")";
    }
  });
});

